import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BackwardArrow icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BackwardArrow } from '@sravni/design-system-icons'
 *
 * <BackwardArrow />
 * ```
 */
var BackwardArrow = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "BackwardArrow", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.736 12.076V12a6 6 0 0 0-6-6H4.737M16.736 12.08V17", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m7.736 9-3-3 3-3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { BackwardArrow };
//# sourceMappingURL=BackwardArrow.js.map
